export const BATTLE_TYPES = {
    ALL_BATTLES: 'all_battles',
    RANDOM_BATTLES: 'random_battles',
    RANDOM_BATTLES_AND_STEEL_HUNTER: 'random_battles_and_steel_hunter',
    CLAN_BATTLES: 'clan_battles',
    SORTIE: 'sortie',
    FORT_BATTLE: 'fort_battle',
    BATTLE_FOR_STRONGHOLD: 'battle_for_stronghold',
    BATTLE_FOR_STRONGHOLD_AND_SORTIE: 'battle_for_stronghold_and_sortie',
}

export const FEATURE_TYPES = {
    PLAYERS_MATCHING: 'players_matching',
    SCHEDULE: 'schedule',
    CLAN_JOURNAL: 'clan_journal',
    LEADERBOARDS: 'elo_leaderboards',
}

export const UNIT_TYPES = {
    SORTIE: 'SORTIE',
    FORT_BATTLE: 'FORT_BATTLE',
}

export const SCHEDULE_TYPES = {
    SORTIE: 'SORTIE',
    FORT_BATTLE: 'FORT_BATTLE',
    CHALLENGES: 'CHALLENGE',
}

export const BONUS_TYPES = {
    EXTRA_CREDITS: 'extra_credits',
    EXTRA_FREE_XP: 'extra_free_xp',
    EXTRA_BATTLE_XP: 'extra_battle_xp',
    EXTRA_CREW_XP: 'extra_crew_xp',
    EXTRA_INDUSTRIAL_RESOURCE: 'extra_industrial_resource',
}

export const RESERVE_PARAMETERS_TYPES = {
    COMMON_AREA_RADIUS: 'commonAreaRadius',
    CREW_ROLES_FACTOR: 'crewRolesFactor',
    DURATION: 'duration',
    COMMON_DELAY: 'commonDelay',
    INACTIVATION_DELAY: 'inactivationDelay',
    MAX_DAMAGE: 'maxDamage',
    AREA_RADIUS: 'areaRadius',
    INSPIRATION_INDUSTRIAL_RESOURCE_BONUS: 'inspirationIndustrialResourceBonus',
    ARTILLERY_STRIKE_INDUSTRIAL_RESOURCE_BONUS: 'artilleryStrikeIndustrialResourceBonus',
}

export const RESERVE_TYPES = {
    BATTLE_PAYMENTS: 'BATTLE_PAYMENTS',
    MILITARY_MANEUVERS: 'MILITARY_MANEUVERS',
    TACTICAL_TRAINING: 'TACTICAL_TRAINING',
    ADDITIONAL_BRIEFING: 'ADDITIONAL_BRIEFING',
    HIGH_CAPACITY_TRANSPORT: 'HIGH_CAPACITY_TRANSPORT',
    REQUISITION: 'REQUISITION',
    ARTILLERY_STRIKE: 'ARTILLERY_STRIKE',
    AIRSTRIKE: 'AIRSTRIKE',
    INSPIRATION: 'INSPIRATION',
}

export const RESERVE_GROUPS = {
    ECONOMIC: 'ECONOMIC',
    DEVELOPMENT: 'DEVELOPMENT',
    DISPOSABLE: 'DISPOSABLE',
}

export const COMMAND_CENTER_ID = 'command_center'

export const BUILDING_TYPES = {
    FINANCIAL_UNIT: 'FINANCIAL_UNIT',
    MILITARY_SCHOOL: 'MILITARY_SCHOOL',
    TANKODROME: 'TANKODROME',
    TRAINING_UNIT: 'TRAINING_UNIT',
    TRANSPORTATION_UNIT: 'TRANSPORTATION_UNIT',
    TROPHY_BRIGADE: 'TROPHY_BRIGADE',
    ARTILLERY_BATTALION: 'ARTILLERY_BATTALION',
    ATTACK_BOMBER_SQUADRONS: 'ATTACK_BOMBER_SQUADRONS',
    HOME_FRONT_SERVICE: 'HOME_FRONT_SERVICE',
}

export const RESOURCE_HISTORY_EVENTS = {
    EARNED_IN_CHALLENGE: 'EARNED_IN_CHALLENGE',
    CHARGED_FOR_CONSTRUCTION: 'CHARGED_FOR_CONSTRUCTION',
    CHARGED_FOR_UPGRADE: 'CHARGED_FOR_UPGRADE',
    CHARGED_FOR_COMMAND_CENTER_UPGRADE: 'CHARGED_FOR_COMMAND_CENTER_UPGRADE',
    CHARGED_FOR_PRODUCTION: 'CHARGED_FOR_PRODUCTION',
    REFUNDED_FOR_PRODUCTION_CANCELLATION: 'REFUNDED_FOR_PRODUCTION_CANCELLATION',
    REFUNDED_FOR_FAILED_MATCHMAKING: 'REFUNDED_FOR_FAILED_MATCHMAKING',
    REFUNDED_BY_ADMINISTRATION: 'REFUNDED_BY_ADMINISTRATION',
    CHARGED_FROM_BACKYARD: 'CHARGED_FROM_BACKYARD',
    REFUNDED_FROM_BACKYARD: 'REFUNDED_FROM_BACKYARD',
    IR_CHANGED_BY_FINE: 'IR_CHANGED_BY_FINE',
    TRADE_CONVOY_SENDING: 'TRADE_CONVOY_SENDING',
    CONVOY_DEFENDED: 'CONVOY_DEFENDED',
    TRADE_CONVOY_RECEIVING: 'TRADE_CONVOY_RECEIVING',
    TRADE_CONVOY_RETURNING: 'TRADE_CONVOY_RETURNING',
    CONVOY_PILLAGE: 'CONVOY_PILLAGE',  // using in wgcwx tax operations for TRADE or TAX convoys
}

export const SORTIE_LEVELS = {
    MIDDLE: 6,
    CHAMPION: 8,
    ABSOLUTE: 10,
    LEGENDARY: 11,
}

export const RESERVES_HISTORY_EVENTS = {
    RESERVE_DELETED_FROM_BACKYARD: 'RESERVE_DELETED_FROM_BACKYARD',
}

export const FORT_BATTLE_SERIES_FINISH_REASONS = {
    BASE: 'BASE',
    FAILURE: 'FAILURE',
    EXTERMINATION: 'EXTERMINATION',
    TECHNICAL: 'TECHNICAL',
    TIMEOUT: 'TIMEOUT',
}

export const FORT_BATTLE_SERIES_RESULT = {
    VICTORY: 'victory',
    DEFEAT: 'defeat',
    DRAW: 'draw',
}

export const USER_FLAGS = {
    USER_WITHOUT_CLAN_SCREEN_VISITED: 'user_without_clan_screen_visited',
    CHALLENGES_PROMO_VISITED: 'challenges_promo_visited',
    SCHEDULE_VISITED: 'schedule_visited',
    LOW_LEVEL_RESERVES_VISITED: 'low_level_reserves_visited',
}

export const USER_ROLES = {
    COMMANDER: 'commander',
    EXECUTIVE_OFFICER: 'executive_officer',
    PERSONNEL_OFFICER: 'personnel_officer',
    COMBAT_OFFICER: 'combat_officer',
    INTELLIGENCE_OFFICER: 'intelligence_officer',
    QUARTERMASTER: 'quartermaster',
    RECRUITMENT_OFFICER: 'recruitment_officer',
    JUNIOR_OFFICER: 'junior_officer',
    PRIVATE: 'private',
    RECRUIT: 'recruit',
    RESERVIST: 'reservist',
}

export const MEDIA_QUERIES = {
    EXTRA_SMALL_WIDTH: '(min-width: 1280px)',
    MEDIUM: '(min-width: 1600px) and (min-height: 900px)',
    LARGE: '(min-width: 2200px) and (min-height: 1100px)',
}

export const BATTLE_MODES = {
    MIDDLE: 'MIDDLE',
    CHAMPION: 'CHAMPION',
    ABSOLUTE: 'ABSOLUTE',
    LEGENDARY: 'LEGENDARY',
}

export const CHALLENGES = {
    SUPERIORITY: 'superiority',
    ONSLAUGHT: 'onslaught',
    SHOOTING: 'shooting',
    CONSCRIPTION: 'conscription',
}

export const CHALLENGES_LIST = [
    CHALLENGES.SUPERIORITY,
    CHALLENGES.ONSLAUGHT,
    CHALLENGES.SHOOTING,
    CHALLENGES.CONSCRIPTION,
]

export const MONEY_TYPES = {
    gold: 'gold',
    credits: 'credits',
    crystal: 'crystal',  // Bonds. Singular.
    bonds: 'bonds',
    industrial_resources: 'industrial_resources',
}

export const BUILDING_TOOLTIP_ID = 'building_tooltip'
export const COMMAND_CENTER_TOOLTIP_ID = 'command_center_tooltip'
export const CAROUSEL_BUILDING_TOOLTIP_ID = 'carousel_building_tooltip'
export const CAROUSEL_COMMAND_CENTER_TOOLTIP_ID = 'carousel_command_center_tooltip'

export const MAX_BUILDING_LEVEL = 10
export const MAX_VEHICLE_LEVEL = 10
export const MAX_RESERVE_LEVEL = 12

export const KEY_CODES = {
    ENTER: 13,
    ESCAPE: 27,
    SPACE: 32,
    UP: 38,
    DOWN: 40,
}

export const SPECIAL_CONDITIONS_X_LEVEL_ONLY = 'X_level_only'

export const MAX_UNIT_PARTICIPANTS = 15

export const ONE_SECOND = 1000
export const ONE_MINUTE = 60 * ONE_SECOND
export const ONE_HOUR = 60 * ONE_MINUTE
export const ONE_DAY = 24 * ONE_HOUR

export const SORTIES_START_INTERIM = 30 * ONE_MINUTE // 30 minutues
export const FORT_BATTLES_START_INTERIM = 60 * ONE_MINUTE // 60 minutes

export const MODERNIZATION_ANIMATION_TIMEOUT = 2800

export const REFRESH_UNITS_COOLDOWN = 3000

export const DIRECTIONS = ['A', 'B', 'C', 'D']

export const VEHICLE_TYPES = [
    'lightTank',
    'mediumTank',
    'heavyTank',
    'AT-SPG',
    'SPG',
]

export const BATTLE_ROOMS_TAB_STATES = {
    UNITS: 'units',
    MATCHING: 'matching',
}

export const LOCAL_STORAGE_KEYS = {
    ALL_VEHICLES: 'allVehicles',
    UNITS_FILTER: 'unitsFilter',
    SELECTED_VEHICLES: 'selectedVehicles',
    VEHICLES_FILTER: 'vehiclesFilter',
    BATTLE_ROOMS_VEHICLE_LEVEL: 'battleRoomsVehicleLevel',
    BATTLE_ROOMS_TAB: 'battleRoomsTab',
    CLAN_QUESTS_INTRO_SHOWN: 'clanQuestsIntroShown',
    CLAN_QUESTS_TUTORIAL_SHOWN: 'clanQuestsTutorialShown',
    LANDING_CLAN_SELECTION_SHOWN: 'landingClanSelectionShown',
    LANDING_CLAN_FILTERS: 'landingClanFilters',
}

/* every realm has its own order of nations
 https://confluence.wargaming.net/pages/viewpage.action?pageId=644225238
 LEGSL-30
 */
export const NATIONS_BY_REALM = {
    ru: ['ussr', 'germany', 'usa', 'france', 'uk', 'czech', 'china', 'japan', 'poland', 'sweden','italy'],
    eu: ['germany', 'ussr', 'usa', 'france', 'uk', 'china', 'japan', 'czech', 'poland', 'sweden','italy'],
    na: ['usa', 'germany', 'ussr', 'uk', 'france', 'czech', 'japan', 'china', 'poland', 'sweden','italy'],
    asia: ['germany', 'ussr', 'usa', 'japan', 'china', 'uk', 'france', 'czech', 'poland', 'italy', 'sweden'],
    cn360: ['china', 'ussr', 'usa', 'germany', 'sweden', 'france', 'italy', 'uk', 'czech', 'poland', 'japan'],
    ct: ['ussr', 'germany', 'usa', 'france', 'uk', 'czech', 'china', 'japan', 'poland', 'sweden','italy'],
}

export const MAX_SET_TIMEOUT_VALUE = 2147483647 // setTimeout takes only 32-bit number

export const MQ_BREAKPOINTS = {
    XXL: 'xxl',
    XL: 'xl',
    L: 'l',
    M: 'm',
    S: 's',
    XS: 'xs',
    XXS: 'xxs',
}

export const REACTIVE_CLAN_MESSAGE_TYPE = {
    BATTLES_UPDATED: 'battles.updated',
    PING: 'ping',
}

export const CLIENT_HEADER_HEIGHT = 54

export const CLAN_SUPPLY_HANGAR_BUBBLE_KEY = 'clansupply_hangar_bubble'



// WEBPACK FOOTER //
// ./constants.js